import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog'
import { Button } from '../components/ui/button'
import { useForm } from 'react-hook-form'
import { useToast } from '../hooks/toast'
import { useRemoteClientDelete } from '@/configs/http-client'
import { useSearchParams } from 'react-router-dom'


type DialogProps = {
  label?: string
  name?: string
  url: string
  unidade?: string
  id: number
  isOpen: boolean
  closeDialog: () => void
  updateList?: () => void
  unit?:boolean
}

export function DialogDelete({ label, name, url, id, isOpen = false, unidade = 'unidadeId',  closeDialog, updateList, unit = true }: DialogProps) {

  const { handleSubmit } = useForm()
  const { showToast } = useToast()
  const { remoteClientDelete } = useRemoteClientDelete()
  const [params] = useSearchParams();
  const onSubmit = async () => {
    try {
      //console.log(id)
      if (unit) {
        await remoteClientDelete(url, `${id}?${unidade}=${params.get('unit')}`)
      } else{
        await remoteClientDelete(url, `${id}`)
      }
      showToast('Excluido...', 'success')
      if (updateList) {
        updateList()
      }
      closeDialog()
    } catch (error: any) {
      console.error(error)
      showToast('Erro ao realizar operação', 'error')
    }
  }

  return (
    <Dialog open={isOpen}>
      <DialogTrigger>
        <DialogContent className="sm:max-w-md">
          <form onSubmit={handleSubmit(onSubmit)}>
            <DialogHeader className='border-acelerafit-gray-dark'>
              <DialogTitle className='text-acelerafit-green-300'>{label ?? "Excluir"}</DialogTitle>
              <DialogDescription>
                {name ? `Deseja excluir: ${name}` : "Excluir..."}
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className="sm:justify-end">
              <Button
                onClick={() => closeDialog()}
                type="button"
                className="hover:opacity-80 transition-all shadow bg-transparent border border-gray-300 rounded px-4 py-2"
                variant="outline"
              >
                Não
              </Button>
              <Button
                type="submit"
                className="bg-acelerafit-green-300 shadow-2xl hover:bg-acelerafit-green-300 hover:opacity-85 transition-all rounded px-4 py-2"
              >
                Sim
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </DialogTrigger>
    </Dialog>
  )
}